/**
 * Ajax Handler (Axios)
 */
import axios from "axios";
import Qs from "qs";

class AjaxHandler {
	constructor() {
		this.$ = jQuery;

		/* Axios cancel params */
		this.CancelToken = axios.CancelToken;
		this.source = this.CancelToken.source();
	}

	/**
	 * Trigger an Ajax POST Request with various options and returns the output
	 * Use promise to return the contents
	 * @param {object} params Specified headers
	 * @param {string} action Specified ajax action (action)
	 * @param {string} loadingOverlay Non-mandatory loading animation
	 */
	postRequest(params = {}, action, loadingOverlay = false) {
		let isCanceled = false;

		if (this.source) {
			this.source.cancel("Cancelling previous request.");
			isCanceled = true;
		}

		this.source = axios.CancelToken.source();

		if (loadingOverlay) {
			$(loadingOverlay).LoadingOverlay("show", {
				imageClass: "jquery-loading-overlay-icon",
				image: ajax.templateUrl + "/assets/svg/loading.svg",
				imageResizeFactor: 1,
				background: "rgba(255, 255, 255, 0.05)"
			});
		}

		const data = {
			is_canceled: isCanceled,
			...params,
			action: action,
			nonce: ajax.nonce
		};

		const options = {
			method: "POST",
			headers: { "content-type": "application/x-www-form-urlencoded" },
			is_canceled: isCanceled,
			data: Qs.stringify(data),
			cancelToken: this.source.token
		};

		return axios(ajax.url, options)
			.then(res => {
				if (loadingOverlay)
					$(loadingOverlay).LoadingOverlay("hide", true);
				return res;
			})
			.catch(error => {
				if (axios.isCancel(error)) {
					console.log(error);
				} else {
					console.log(error.response);
				}
			});
	}
}

export default AjaxHandler;
